module.exports = __webpack_public_path__ + "static/media/Emoji_hero_1.fa845ab2.jpg";